import { AxiosError, AxiosResponse } from "axios";
import http from "utilities/http-common";
const baseUrl = "/api/Locations";

export async function getLocationNames(tenantId?: string): Promise<string[]> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }
    return http
        .get(`${baseUrl}/names`, { params })
        .then((resp: AxiosResponse<string[]>) => {
            return resp.data;
        });
}

export async function getLocations(): Promise<LocationList[]> {
    return http
        .get(baseUrl)
        .then((resp: AxiosResponse<LocationList[]>) => {
            return resp.data;
        });
}

export async function getAllLocations(tenantId?: string): Promise<AdminLocationList[]> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }

    return http
        .get(`${baseUrl}/all`, { params })
        .then((resp: AxiosResponse<AdminLocationList[]>) => {
            return resp.data;
        });
}

export async function updateNameLocation(id: string, name: string, tenantId?: string): Promise<AdminLocationList> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }

    return http.put(`${baseUrl}/?id=${id}&newName=${name}`, params, {params: params}).then((res: AxiosResponse<AdminLocationList>) =>
        res.data
    )
}

export async function deleteNameLocation(id: string, tenantId?: string) {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }

    return http.delete(`${baseUrl}/?id=${id}`, { params }).then((res: AxiosResponse) => res);
}

export async function reActivate(id: string, tenantId?: string): Promise<AdminLocationList> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }

    return http.post(`${baseUrl}/reactivate/?id=${id}`, params, {params: params})
        .then((res: AxiosResponse<AdminLocationList>) => res.data);
}

export async function createLocation(name: string, tenantId?: string): Promise<AdminLocationList> {
    const params = new URLSearchParams();
    if (tenantId)
    {
        params.append("tenantId", tenantId);
    }

    return http.post(`${baseUrl}?name=${name}`, params, {params: params})
        .then((res: AxiosResponse<AdminLocationList>) => res.data);
}
